import $ from 'jquery';
import Mark from 'mark.js';

/* global x5script */

class SearchHighlight {
  constructor() {
    this.enable = x5script.searchHighlight.enable;
    this.searchedPhrase = x5script.searchHighlight.phrase;
    this.searchArea = $('.js-searched');

    if (!this.enable || this.searchedPhrase === '' || !this.searchArea.length) {
      return;
    }

    this.accuracy = x5script.searchHighlight.accuracy;
    this.scrollToFirst = x5script.searchHighlight.scroll;

    this.init();
    this.scroll();
  }

  init() {
    const instance = new Mark(document.querySelector('.js-searched'));

    instance.mark(this.searchedPhrase, {
      accuracy: this.accuracy, // partially, exactly, complementary
      className: 'js-search-highlight',
    });
  }

  scroll() {
    $(window).on('load', () => {
      if (this.scrollToFirst) {
        const firstHighlight = $('.js-search-highlight').first();
        let scrollPos = firstHighlight.offset().top - 100;

        if ($('body').hasClass('has-sticky-header')) {
          scrollPos -= $('.js-header').outerHeight();
        }

        if (firstHighlight.length) {
          $('body, html')
            .stop()
            .animate(
              {
                scrollTop: scrollPos,
              },
              500,
            );
        }
      }
    });
  }
}

export default new SearchHighlight();



// WEBPACK FOOTER //
// ./src/scripts/modules/search-highlight.js